import { ACCOUNTS_PATH, ACCOUNT_CREATION_PATH } from '@/components/Entities/paths';

// The account creation page's route, in the `*.route.ts` shape of partnerPage.route.ts; imported as
// `import * as accountCreationRoute`.
export const id = 'accountCreation';

/** Both open the page; the second is the older path under the list, kept for existing links. */
export const path = [ACCOUNT_CREATION_PATH, `${ACCOUNTS_PATH}/create`];

export function getPath() {
  return ACCOUNT_CREATION_PATH;
}
